function cov_1dmvb5101b() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SignFilled.tsx";
  var hash = "1fa8fa53f7608455f569b3f016af186dfae25e39";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SignFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1fa8fa53f7608455f569b3f016af186dfae25e39"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1dmvb5101b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1dmvb5101b();
var Icon = (cov_1dmvb5101b().s[0]++, {
  name: 'sign-filled',
  svg: "<path d=\"M5.25 3C5.25 2.30964 4.69036 1.75 4 1.75C3.30964 1.75 2.75 2.30964 2.75 3V3.75H2C1.30964 3.75 0.75 4.30964 0.75 5C0.75 5.69036 1.30964 6.25 2 6.25H2.75L2.75 22.05H5.25L5.25 6.25H21C21.6904 6.25 22.25 5.69036 22.25 5C22.25 4.30964 21.6904 3.75 21 3.75H5.25V3Z\" fill=\"currentColor\"/>\n  <path d=\"M7 11C7 9.34315 8.34315 8 10 8H19C20.6569 8 22 9.34315 22 11V17C22 18.6569 20.6569 20 19 20H10C8.34315 20 7 18.6569 7 17V11Z\" fill=\"currentColor\"/>"
});
export default Icon;